var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "v-application" },
    [
      _c(
        "v-col",
        { staticClass: "pb-0", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            {
              staticClass: "rounded-lg mx-5 mt-3 v-application",
              attrs: { outlined: "", elevation: "0" },
            },
            [
              _c("v-card-title", { staticClass: "d-inline-block" }, [
                _c("span", { staticClass: "h4" }, [
                  _vm._v(
                    "\n                    Wunschprofil des FB\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "d-inline-block" }, [
                _c("div", { staticClass: "d-flex flex-wrap" }, [
                  _vm.pharmacy.desired_pharmacist_gender
                    ? _c("span", { staticClass: "ml-5" }, [
                        _c("span", { staticClass: "h5" }, [
                          _vm._v("Geschlecht: "),
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm.pharmacy.pretty_desired_pharmacist_gender
                          ) + "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pharmacy.desired_pharmacist_languages.length
                    ? _c(
                        "span",
                        { staticClass: "ml-4" },
                        [
                          _c("span", { staticClass: "h5" }, [
                            _vm._v("Sprachen: "),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.pharmacy.pretty_desired_pharmacist_languages,
                            function (lang) {
                              return _c("span", [_vm._v(_vm._s(lang) + ", ")])
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pharmacy.desired_pharmacist_languages_ext
                    ? _c("span", { staticClass: "ml-4" }, [
                        _c("span", { staticClass: "h5" }, [
                          _vm._v("weitere Sprachen: "),
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm.pharmacy.desired_pharmacist_languages_ext
                          ) + "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pharmacy.desired_pharmacist_annotation
                    ? _c("span", { staticClass: "ml-4" }, [
                        _c("span", { staticClass: "h5" }, [
                          _vm._v("Anmerkungen: "),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "textarea-comment" }, [
                          _vm._v(
                            _vm._s(_vm.pharmacy.desired_pharmacist_annotation)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "v-application align-center", attrs: { cols: "12" } },
        [
          _c("v-text-field", {
            staticClass: "mx-4 pt-0 mt-0",
            attrs: {
              "append-icon": "mdi-magnify",
              label: "Suche",
              "hide-details": "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "v-application--is-ltr" },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.filterOptions,
                  label: "Filter",
                  outlined: "",
                  clearable: "",
                  dense: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.filter,
                  callback: function ($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "open-pharmacist-favorite-list ml-3",
              attrs: { color: "success", small: "", outlined: "" },
              on: {
                click: function ($event) {
                  _vm.isFavoritesDialogOpen = true
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
                _vm._v("mdi-pencil"),
              ]),
              _vm._v(" FB - Favoriten-Liste\n        "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "open-pharmacist-blacklist mx-3",
              attrs: { color: "error", small: "", outlined: "" },
              on: {
                click: function ($event) {
                  _vm.isBlacklistDialogOpen = true
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
                _vm._v("mdi-pencil"),
              ]),
              _vm._v(" FB - Negativ-Liste\n        "),
            ],
            1
          ),
          _vm._v(" "),
          _c("favorite-pharmacist-dialog", {
            attrs: {
              pharmacyId: _vm.pharmacy._id,
              activePharmacists: _vm.activePharmacists,
              favoriteIds: Object.keys(_vm.pharmacy.contractor_favorite_list),
            },
            on: {
              "get-pharmacists": function ($event) {
                return _vm.$emit("get-pharmacists")
              },
            },
            model: {
              value: _vm.isFavoritesDialogOpen,
              callback: function ($$v) {
                _vm.isFavoritesDialogOpen = $$v
              },
              expression: "isFavoritesDialogOpen",
            },
          }),
          _vm._v(" "),
          _c("blacklist-pharmacist-dialog", {
            attrs: {
              pharmacyId: _vm.pharmacy._id,
              activePharmacists: _vm.activePharmacists,
              blacklistIds: _vm.pharmacy.contractor_black_list,
            },
            on: {
              "get-pharmacists": function ($event) {
                return _vm.$emit("get-pharmacists")
              },
            },
            model: {
              value: _vm.isBlacklistDialogOpen,
              callback: function ($$v) {
                _vm.isBlacklistDialogOpen = $$v
              },
              expression: "isBlacklistDialogOpen",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("v-data-table", {
            staticClass: "v-application--is-ltr",
            attrs: {
              headers: _vm.headers,
              items: _vm.filter ? _vm.filteredtableRows : _vm.tableRows,
              "items-per-page": 15,
              search: _vm.search,
              "item-key": "_id",
              "no-data-text": "Keine Suchergebnisse",
              "loading-text": "Wird geladen...",
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ item }) {
                  return [
                    _c("pharmacists-table-row", {
                      attrs: { pharmacist: item },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }